
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"19.556","height":"19.556"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.707 .707)"}},[_c('circle',{attrs:{"cx":"6.414","cy":"6.414","r":"6.414","transform":"rotate(-45 10.95 4.535)","fill":"none","stroke":"#1473e6","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"3.414","cy":"3.414","r":"3.414","transform":"rotate(-45 13.071 -.586)","fill":"#1473e6"}})])])
          )
        }
      }
    